import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const cardStyles = css`
	${strictBreakpoints.onlyMobile} {
		width: 125px;
		margin-right: 13px;
	}
	a {
		display: block;
		margin-bottom: 16px;
		border-radius: 4px;
		img {
			width: 100%;
			height: 170px;
			${strictBreakpoints.onlyTablet} {
				height: 141px;
			}
			${strictBreakpoints.onlyMobile} {
				height: 125px;
			}
		}
	}
`;
